'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _account = require('./account.routes');

var _account2 = _interopRequireDefault(_account);

var _login = require('./login');

var _login2 = _interopRequireDefault(_login);

var _settings = require('./settings');

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('fiapiApp.account', [_angularUiRouter2.default, _login2.default, _settings2.default]).config(_account2.default).run(function ($rootScope) {
  'ngInject';

  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
    if (next.name === 'logout' && current && current.name && !current.authenticate) {
      next.referrer = current.name;
    }
  });
}).name;


// WEBPACK FOOTER //
// ./client/app/account/index.js